import * as Yup from 'yup';
import i18next from 'i18next';

const t = i18next.t.bind(i18next);

export const validators = {
    firstName: Yup.string().required(t('validators.firstName.required')),
    lastName: Yup.string().required(t('validators.firstName.required')),
    jobTitle: Yup.string(),
    email: Yup.string()
        .email(t('validators.email.invalid'))
        .required(t('validators.email.required')),
    phone: Yup.string()
        .trim()
        .matches(/^[0-9]{8}$/, t('validators.phone.invalid'))
        .required(t('validators.phone.required')),
    password: Yup.string()
        .required(t('validators.password.required'))
        .matches(
            /(?=^.{8,}$)(?=.*\W+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
            t('validators.password.invalid')
        ),
};
